<template>
  <!-- NOTES -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer feather-icon">
    <feather-icon icon="MessageSquareIcon" class="cursor-pointer mx-2" :badge="notes.length" />
<!--     {{notes}}-->
    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ notes.length }} <span class="opacity-75">{{ $t("notes.title") }}</span></h3>
      </div>
      <vs-prompt
          title="Discussion"
          :cancel-text="$t('Cancel')"
          :active.sync="chatPopup"
      >
      </vs-prompt>
      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items"  style='min-height:211px'>
            <li v-for="ntf in notes" :key="ntf.id || ntf._id"  class="flex justify-between px-4 py-4 notification cursor-pointer">            <div class="flex items-start w-full">
              <div class="w-full">
                <span v-if="ntf.noteType===0" class="flex items-center" >
                  <feather-icon icon="MessageSquareIcon" class="mr-2" :svgClasses="[`text-primary`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                  <span class="font-medium block notification-title" :class="[`text-primary`]">{{ $t("notes.lbl1_opt0") }} {{ $t("notes.msg_prefix") }} {{ ntf.firstName }} </span>
                  <br>

                </span>
                <span v-if="ntf.noteType===1" class="flex items-center">
                  <feather-icon icon="PackageIcon" class="mr-2" :svgClasses="[`text-info`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                  <span class="font-medium block notification-title" :class="[`text-info`]">{{ $t("notes.lbl1_opt1") }} {{ $t("notes.msg_prefix") }} {{ ntf.firstName }} </span>
                </span>
                <span v-if="ntf.noteType===2" class="flex items-center">
                  <feather-icon icon="AlertOctagonIcon" class="mr-2" :svgClasses="[`text-danger`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                  <span class="font-medium block notification-title" :class="[`text-danger`]">{{ $t("notes.lbl1_opt2") }} {{ $t("notes.msg_prefix") }} {{ ntf.firstName }} </span>
                </span>
                <span v-if="ntf.noteType===3" class="flex items-center">
                  <feather-icon icon="MailIcon" class="mr-2" :svgClasses="[`text-secondary`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                  <span class="font-medium block notification-title" :class="[`text-secondary`]">{{ $t("notes.lbl1_opt3") }} {{ $t("notes.msg_prefix") }} {{ ntf.firstName }} </span>
                </span>
                <span v-if="ntf.noteType===4" class="flex items-center">
                  <feather-icon icon="CalendarIcon" class="mr-2" :svgClasses="[`text-warning`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                  <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ $t("notes.lbl1_opt4") }} {{ $t("notes.msg_prefix") }} {{ ntf.firstName }} on {{ new Date(ntf.meetingDate) | moment('YYYY-MM-DD')}} </span>
                </span>
                <div class="con-img mt-2 flex items-center">
                  <img v-if="ntf.avatar!==null" :src="ntf.avatar" class="mr-2" width="25" height="25" style="border-radius: 100%;"/>
                  <img v-else src="@/assets/images/profile/avatar.png" class="mr-2" width="25" height="25" style="border-radius: 100%;">
                   <div class="flex flex-col">
                    <small v-html="ntf.message"></small>
                    
                    <!-- Meeting URL Display -->
                    <a v-if="ntf.noteType === 4 && ntf.meetingUrl" 
                       :href="ntf.meetingUrl.startsWith('http') ? ntf.meetingUrl : 'https://' + ntf.meetingUrl" 
                       target="_blank" 
                       class="text-primary mt-1 hover:underline" 
                       style="font-size: 0.75rem;"
                       @click.stop>
                      🔗 {{ ntf.meetingUrl }}
                    </a>
                  </div>
<!--                  <small>{{ ntf.message }} <feather-icon icon="EditIcon" @click="chatModel" class="cursor-pointer ml-4 mr-6 mt-1" ttile="Relpy"  /></small>-->
                </div>
              </div>
              <div class="ml-2">
                <div class="text-right">
                  <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdAt) }}</small><br />
                  <feather-icon icon="TrashIcon" class="cursor-pointer mt-1 secondary" @click="removeNote(ntf.id || ntf._id)"></feather-icon>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </component>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        vs-tabs-div">
          <div class="flex justify-center mb-1">
          <label class="align-middle cursor-pointer" v-on:click="activePrompt = !activePrompt">
            {{ $t("notes.lbl0") }}
            <feather-icon :icon="activePrompt?'ChevronsDownIcon':'ChevronsUpIcon'" class="cursor-pointer align-middle" />
          </label>
          </div>
          <div class="relative mt-1" v-if="activePrompt">
            <div class="flex justify-between mb-1">
              <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl1") }}</label>
              <v-select
                item-text="label"
                item-value="value"
                v-model="noteType"
                :clearable="false"
                class="w-full text-primary mt-1"
                :options="noteTypeOptions"
                v-validate="'required'"
                name="noteType"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
            <div v-if="noteType.value===4" class="flex justify-between my-2">
              <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl3") }}</label>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full flex flex-wrap">
                  <vs-input
                    v-model.number="startH"
                    type="number"
                    color="warning"
                    :min="0"
                    :max="23"
                    @change="setDate()"
                    @keyup="setDate()"
                    placeholder="HH"
                    id="startHour"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full flex flex-wrap">
                  <vs-input
                    v-model.number="startM"
                    type="number"
                    color="warning"
                    :min="0"
                    :max="59"
                    @change="setDate()"
                    @keyup="setDate()"
                    placeholder="MM"
                    id="startMinute"
                  />
                </div>
              </div>
            </div>
            <div v-if="noteType.value===4" class="flex justify-between my-2">
              <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl4") }}</label>
              <select
                class="selectType w-full dropdown timezone-select"
                v-model="timezone"
                @change="setDate()"
              >
                <optgroup label="Most Used Timezone">
                  <option value="Asia/Kolkata" class="mt-4">Asia/Calcutta</option>
                  <option value="Europe/Lisbon">Europe/Lisbon</option>
                  <option value="GMT" class="mb-4">GMT</option>
                </optgroup>
                <optgroup label="All Timezones">
                  <option
                    :key="index"
                    v-for="(allTimeZoneData, index) in allTimeZone"
                    :value="allTimeZoneData.value"
                  >
                    {{ allTimeZoneData.value }}
                  </option>
                </optgroup>
              </select>
            </div>
            <div v-if="noteType.value===4" class="flex justify-between my-2">
              <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl2") }}</label>
               <datePicker id="weekend-datetime-picker"
                v-model="meetingDate"
                name = "meetingDate"
                class="text-primary bg-none w-full"
                :value="meetingDate"
                :format="DatePickerFormat"
                :disabledDates="disabledDates"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"></datePicker>
            </div>
            <!-- NEW: Meeting Link Toggle -->
            <div v-if="noteType.value===4" class="flex justify-between my-2 items-center">
              <label class="mt-2 mr-1 align-middle label fix-label text-left text-sm font-semibold">Use My Meeting Link?</label>
              <div class="flex items-center w-full mt-2">
                <vs-switch v-model="useMyMeetingLink" class="mr-2" color="success" />
                <span v-if="useMyMeetingLink" class="text-sm text-grey truncate opacity-75 ml-2" style="max-width: 170px;">
                  <i v-if="myMeetingLink">{{ myMeetingLink }}</i>
                  <i v-else>No link saved in profile</i>
                </span>
              </div>
            </div>

            <!-- EXISTING (Modified): Custom Input only shows if toggle is false -->
            <div v-if="noteType.value===4 && !useMyMeetingLink" class="flex justify-between my-2">
              <label class="mt-2 mr-1 align-middle label fix-label text-left">Meeting Link</label>
              <vs-input
                v-model="meetingUrl"
                class="w-full text-primary"
                placeholder="Optional (e.g. abc.com)"
              />
            </div>
            <div class="relative">
              <vs-textarea
              v-validate="'required'"
              v-model="msg"
              name="msg"
              class="my-4 resize-0"
              placeholder="Meeting Purpose"
              >
              <!-- :maxlength="255"
              @keyup="checkMessageLength()" -->
              </vs-textarea>
              <!-- <span class="absolute bottom-0 right-0 mr-2">{{msgLength}} / <strong>255</strong></span> -->
            </div>
            <vs-button class="primary mr-1 my-1" type="filled" @click="createNote" :disabled="this.msg==null?true:false">{{ $t("Save") }}</vs-button>
          </div>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>
<script>
import Vue from "vue";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { models } from "feathers-vuex"
import vSelect from "vue-select"
import datePicker from "vuejs-datepicker"
import Moment from 'vue-moment';
import i18n from '../../../../i18n/i18n';
import allTimeZone from './allTimeZone';
import moment from 'moment';
Vue.use(Moment);

export default {
  name: 'trainee-coach-notes',
  props: {
    commuId: {type:[String,Array,Object,Number], default: ''}
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    datePicker,
    moment

  },
  data: function () {
    return {
      meetingUrl: null,
      useMyMeetingLink: false,
      myMeetingLink: null,
      meetingDate: new Date(),
      DatePickerFormat: 'dd/MM/yyyy',
        disabledDates: {
          to: new Date(Date.now() - 8640000)
        },
      startH:
        moment().minutes() + 5 > 59
          ? (moment().hours() + 1) % 24
          : moment().hours() % 24,
      startM: (moment().minutes() + 5) % 60,
      activePrompt: false,
      schedule_time:'',
      timezone:'',
      userRole : this.$store.state.AppActiveUser.userType,
      msg : null,
      msgLength : 0,
      communicationId:'',
      userId: this.$store.state.AppActiveUser.usersId,
      noteType:{
        label:i18n.t("notes.lbl1_opt0"),
        value:0
      },
      noteTypeOptions: [
        { label:i18n.t("notes.lbl1_opt0"), value: 0 },
        { label:i18n.t("notes.lbl1_opt1"), value: 1 },
        { label:i18n.t("notes.lbl1_opt2"), value: 2 },
        { label:i18n.t("notes.lbl1_opt3"), value: 3 },
        { label:i18n.t("notes.lbl1_opt4"), value: 4 }
      ],
      allTimeZone,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      notes:[],
      query:null,
      chatPopup:false
    }
  },
  computed:{
    scrollbarTag: function() { return this.$store.getters.scrollbarTag },

  },
  methods: {
    injectNewNote: async function(res) {
      try {
        const userDetail = await this.$store.dispatch("userManagement/fetchUser", res.authorId);
        const newNote = {
          ...res,
          id: res.id || res._id, // <-- Guarantees the ID is perfectly set
          firstName: userDetail.firstName,
          lastName: userDetail.latName || userDetail.lastName,
          avatar: userDetail.avatar
        };
        // Force Vue to update the array instantly
        this.notes = [newNote, ...this.notes];
      } catch (err) {
        console.error("Error injecting note", err);
        res.id = res.id || res._id; 
        this.notes = [res, ...this.notes]; // Fallback
      }
    },

    // count msg length
    chatModel(){
      this.chatPopup=true;
    },
    checkMessageLength:function(){
      this.msgLength = this.msg.length;
    },
    elapsedTime:function(startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate: function({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    },
    formatMessage(text) {
      if (!text) return '';
      const urlRegex = /(https?:\/\/[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
      return text.replace(urlRegex, function(url) {
        let href = url;
        if (!href.match('^https?:\/\/')) {
          href = 'http://' + href;
        }
        return `<a href="${href}" target="_blank" class="text-primary hover:underline" style="font-weight:bold;">${url}</a>`;
      });
    },

    // create note
    createNote: async function(){
      if(this.noteType.value === 4){
        this.startD = moment.utc(this.meetingDate).format('YYYY-MM-DD');
        this.schedule_time = this.startD + ' ' + this.startH + ':' + this.startM + ':00';
      } else {
        this.schedule_time = null;
      }

      // 1. Check which link to use based on the toggle
      let finalMeetingUrl = this.useMyMeetingLink ? this.myMeetingLink : this.meetingUrl;
      
      // 2. Combine the message and URL so the Database saves it automatically!
      let finalMessage = this.msg;
      if (this.noteType.value === 4 && finalMeetingUrl) {
        finalMessage = this.msg + '<br><br>📍 <strong>Meeting Link:</strong> ' + finalMeetingUrl;
      }

      const note = new models.api.Usercoach_Notes({
        userRole: this.userRole,
        noteType: this.noteType.value,
        authorId: this.userId,

        commuId: this.communicationId,
        company:window.$cookies.get('companyName'),
        loginType:this.$store.state.AppActiveUser.userType,
        message: finalMessage, // <-- Send the combined message
        timezone:this.timezone,
        status: 0,
        meetingDate: this.schedule_time
      });

      try {
        // Send to backend
        const res = await this.$store.dispatch("notesManagement/addNote", note);
        
        this.$vs.notify({
          title: "Success",
          text: "Note Added Successfully",
          color: "primary"
        });

        // 2. REAL-TIME UI UPDATE FIX (NO REFRESH NEEDED)
        // Fetch the user's avatar/name for the newly created note
        const userDetail = await this.$store.dispatch("userManagement/fetchUser", res.authorId);
        
        // Build the new note object manually
        const newNote = {
          ...res,
          firstName: userDetail.firstName,
          lastName: userDetail.latName || userDetail.lastName,
          avatar: userDetail.avatar
        };

        // 3. Force Vue to instantly push it to the top of the list!
        this.notes = [newNote, ...this.notes];
        
      } catch (err) {
        this.$vs.notify({
          title: "Failed",
          text: "Note Create Failed",
          color: "danger"
        });
      }

      // 4. Clear fields
      this.msg = null;
      this.meetingUrl = null;
    },
    fetchNotes: async function(){
      try {
        const res = await this.$store.dispatch("notesManagement/fetchNotes", { query: this.query });
        
        // Wait for all user details to load, then create a brand new array
        const processedNotes = await Promise.all(res.data.map(async (note) => {
          try {
            const userDetail = await this.$store.dispatch("userManagement/fetchUser", note.authorId);
            return {
              ...note,
              firstName: userDetail.firstName,
              lastName: userDetail.latName || userDetail.lastName,
              avatar: userDetail.avatar
            };
          } catch(err) {
            console.error("cant fetch user", err);
            return note;
          }
        }));

        // Assigning the complete array at once triggers Vue's real-time UI update!
        this.notes = processedNotes; 
      } catch (err) {
        console.error(err);
      }
    },
    removeNote: function(id){
      if(!id) return; // Prevent empty calls

      let note = {
        id: id,
        status: 1
      }

      // 1. OPTIMISTIC UPDATE: Instantly remove the note from the UI!
      const previousNotes = [...this.notes];
      this.notes = this.notes.filter(n => n.id !== id && n._id !== id);

      this.$store.dispatch("notesManagement/removeRecord", note)
      .then(res => {
        this.$vs.notify({
          title: "Success",
          text: "Note Removed Successfully",
          color: "primary"
        });
      })
      .catch(err => {
        // 2. Ignore the strict Vuex "findIndex" mutation error because the DB call actually succeeded!
        if (err && err.toString().includes('findIndex')) {
          this.$vs.notify({
            title: "Success",
            text: "Note Removed Successfully",
            color: "primary"
          });
        } else {
          console.log("Can't Remove", err);
          // Revert the UI if it actually failed at the database level
          this.notes = previousNotes;
          this.$vs.notify({
            title: "Failed",
            text: "Note Deletion Failed",
            color: "danger"
          });
        }
      });
    },
  },
  mounted (){},
  created(){
    let query=''
    if(this.userRole === 'coach'){
      query = {$and:[{coachId:this.userId},{traineeId:this.commuId}]}
    }
    else if(this.userRole === 'trainee'){
      query = {traineeId:this.$store.state.AppActiveUser.usersId}
    }
    this.$store
      .dispatch("traineeCoachAssignment/fetchAssignTraineeCoachQuery", {
        query: query
      })
      .then(res => {
        let receiverId;
        if(res.data.length===1){
          if(this.userRole === 'trainee'){
            receiverId = res.data[0].coachId;
            this.communicationId = receiverId;
          }
          if(this.userRole === 'coach'){
            receiverId = res.data[0].traineeId;
            this.communicationId = receiverId;
          }
        }
        else if(res.data.length===0){
          receiverId = this.commuId;
          this.communicationId = this.commuId;
        }
        else{
          console.log("something is wrong we have found more than 1 data")
        }
        this.query = {$and:[{authorId:{$in:[this.userId,receiverId]}},{commuId:{$in:[this.userId,receiverId]}},{status:0}], $sort: { createdAt: -1 } }
        this.fetchNotes();
      })
      .catch(err => {
        console.log("trainee coach not found", err);
      });
      // Fetch Coach's saved Meeting Link from profile
    this.$store.dispatch("userManagement/fetchUser", this.userId).then(res => {
      // Adjust this based on your exact DB column name for the personal URL
      this.myMeetingLink = res.meetingLink || res.meetingUrl || null; 
    }).catch(err => console.error("Could not fetch personal meeting link", err));
  }
}

</script>
<style lang="scss">
.fix-label{
  width:145px;
}
.bg-none,#weekend-datetime-picker{
  background: transparent;
}
 .vdp-datepicker__calendar{
   right:0px
 }
</style>
